import styles from '../../ArtikelLoseWareTable/LoseWareList.module.scss';
import { PropertyEntryProps } from '../types';
import { BestellpositionArtikelLoseWareView, ArtikelZulagePayload } from '../../../../types';

function renderZulageItem(item: ArtikelZulagePayload, index: number): JSX.Element {
    return (
        <span key={index} className={styles._zulagePill}>
            {typeof item === 'string'
                ? item
                : `${item.bezeichnung ?? (item as { name?: string }).name ?? ''}${
                      typeof item.dosierung === 'number' ? ` (${item.dosierung})` : ''
                  }`}
        </span>
    );
}

export const ZulageDisplayList = ({ bestellposition }: PropertyEntryProps<BestellpositionArtikelLoseWareView>): JSX.Element | null => {
    const entries = bestellposition.zulagen;
    if (!Array.isArray(entries) || entries.length === 0) return null;
    return <div className={styles._zulageDisplayRow}>{entries.map(renderZulageItem)}</div>;
};
